module.exports = __webpack_public_path__ + "img/dots_mtb4.ac17df76.png";